var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.href,"target":"_blank","rel":"external nofollow noopener"}},[_vm._t("default"),_vm._v(" "),(_vm.shown)?_c('FontAwesomeIcon',{staticClass:"fa-xs",attrs:{"icon":"fas fa-external-link"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }